import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReportDetail } from '@/features/ReportDetail';
import { useDocumentTitle, useResetQueryState } from '@/hooks';
import { BackButton } from '@/components';
import { AppRoutes } from '@/constants/routes';

interface ReportPageLocationState {
    readonly forceBackToReports?: boolean;
}

export default function ReportPage() {
    useResetQueryState();
    const { reportId } = useParams<{ reportId: string }>();
    const location = useLocation();
    const navigate = useNavigate();
    const [reportName, setReportName] = useState<string | undefined>();
    const forceBackToReports = Boolean(
        (location.state as ReportPageLocationState | null)?.forceBackToReports,
    );

    useDocumentTitle('reports', reportName);

    if (!reportId) {
        return (
            <div className="h-full flex items-center justify-center px-8">
                <p className="text-red-400">Report ID not provided</p>
            </div>
        );
    }

    return (
        <div className="h-full relative">
            <BackButton
                variant="floating"
                onBack={
                    forceBackToReports
                        ? () => navigate(AppRoutes.REPORTS, { replace: true })
                        : undefined
                }
            />
            <ReportDetail
                key={reportId}
                reportId={reportId}
                onReportNameResolved={setReportName}
            />
        </div>
    );
}
